interface BasePerk {
  id:                 number;
  tier:               number;
  statusId:           number;
  rating:             number;
  provinces:          string[];
  range:              string[];
  languages:          string[];
  title:              string;
  offer:              string;
  description:        string;
  validFrom:          Date;
  validTo:            Date;
  category:           PerkCategory;
  subcategory:        PerkCategory;
  locations:          PerkLocation[];
  keywords:           string[];
  labels:             string[];
  images:             PerkImages;
  redemptions:        PerkRedemption;
  restrictionType:    string;
  restrictedSites:    number[];
  isExpress:          boolean;
  isNew:              boolean;
  codes:              PerkCode[];
  hideFromChildUser:  boolean;
  hideFromMobile:     boolean;
  accountId:          number;
  campaign_id:        number;
  index:              number;
  statusChanged:      Date;
  links:              PerkLink;
  customTerms:        string;
  customTemplate:     string;
  source:             PerkSource;
  templateId?:        number;
  searchQuery?:       string;
  promotionId?:       number;
  promotion?:         PerkPromotion;
  sponsored_result?:  number;
  sponsored_keyword?: number;
  position?:          number;
  keyword?:           string;
}

export interface VenngoPerk extends BasePerk {

}

export interface ADPerk extends BasePerk {
  groupID: number;
  source: PerkSource;
  storeKey: string;
}

export interface PerkCategory {
  id: number;
  term: string;
}

export interface PerkPromotion {
  id: number;
  start_date: string;
  end_date: string;
}

export interface PerkLink {
  perkDetails: string[];
  websiteLink: string[];
  socialLinks: string[];
}

export interface PerkCode {
  code: string;
}

export interface PerkImages {
  logo: string;
  heroBanner: string;
  heroBannerMobile: string;
  featureBanner: string;
  featureBannerMobile: string;
  bigBox: string;
  barcode: string;
  brandImages: string[];
  stories: string[];
}

export interface LiveReport {
  billing_city: string;
  billing_prov: string;
  rep: string;
  eps: Eps;
}

export interface Eps {
  key: string;
  saving_rate: string;
  average_spend: string;
  redemption_rate: string;
}

export interface PerkLocation {
  id: number
  latitude: number;
  longitude: number;
  address_hours: AddressHours;
  distance?: any;
  pin: Pin;
  visible: boolean;
}

export interface AddressHours {
  address: string;
  address_line_1: string;
  city: string;
  country: string;
  daysOfOperation: string[];
  hasHours: boolean;
  hasOpeningHours: boolean;
  placeID: string[];
  postalCode: string;
  province: string;
  visible: boolean;
}

export interface Pin {
  lon: number;
  lat: number;
}

export interface Usage {
  unlimitedUses: boolean;
  periodOfUses: string;
  usesPerPeriod: string;
  usable: null;
  usesRemaining: null;
}
export interface Redeem {
  instore: null;
  instore_print: null;
  call: null;
}

export interface PerkRedemption {
  instore: null;
  instore_print: null;
  mobile: null;
  online: null;
  email: null;
}

export interface Account {
  id: string | number;
  accountLogo?: object;
  companyName?: string;
  source: PerkSource;
  groupID?: string | number;
  position?: string | number
}

export interface Campaign {
  id: string | number;
}

export enum PerkSource {
  AccessDevelopment = 'ad',
  Venngo = 'es',
}

export function isVenngoPerk(perk: Perk): perk is VenngoPerk {
  return perk.source !== PerkSource.AccessDevelopment;
}

export function isADPerk(perk: Perk): perk is ADPerk {
  return perk.source === PerkSource.AccessDevelopment;
}

type Perk = VenngoPerk | ADPerk;

export default Perk;

export type PerkIdentifier = string | number;

export const PERK_ACTIONS_SOURCE_MAP = {
  [PerkSource.Venngo]: 1,
  [PerkSource.AccessDevelopment]: 2,
};

export interface DaysOfOperationHours {
  closed: boolean;
  from: {
      hh: string;
      mm: string;
      A: string;
  },
  to: {
      hh: string;
      mm: string;
      A: string;
  },
};